import { render } from "./upload-manual.vue?vue&type=template&id=60d6e22f&scoped=true"
import script from "./upload-manual.vue?vue&type=script&lang=js"
export * from "./upload-manual.vue?vue&type=script&lang=js"

import "./upload-manual.vue?vue&type=style&index=0&id=60d6e22f&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d6e22f"]])

export default __exports__